module.exports = __webpack_public_path__ + "img/product_main.0adc204f.png";